import React, { useEffect, useRef } from "react";

const GoogleBrandingIframe = ({ html }) => {
  const iframeRef = useRef(null);

  useEffect(() => {
    if (iframeRef.current && html) {
      const doc = iframeRef.current.contentDocument;
      if (doc) {
        doc.open();
        doc.write(`
          <!DOCTYPE html>
          <html>
            <head>
              <style>
                body { margin: 0; padding: 0; overflow: hidden; }
              </style>
            </head>
            <body>
              ${html}
            </body>
          </html>
        `);
        doc.close();
      }
    }
  }, [html]);

  return (
    <iframe
      ref={iframeRef}
      title="Google Search Branding"
      style={{
        width: '100%',
        height: '60px',
        border: 'none',
        overflow: 'hidden'
      }}
      scrolling="no"
    />
  );
};

// This line is what was missing/mismatched causing your error
export default GoogleBrandingIframe;


// WEBPACK FOOTER //
// ./src/components/ai/GoogleBrandingIframe.js